import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as State from '@shared/state';
import * as Models from '@shared/core/models';
import * as selectors from '@shared/state/selectors';
import * as actions from '@shared/state/actions';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { withLatestFrom, take } from 'rxjs/operators';

@Component({
    selector: 'shared-collection-type-toggle',
    templateUrl: './collection-type-toggle.shared.component.html',
    styleUrls: ['./collection-type-toggle.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionTypeToggleComponent implements OnInit {
    @Input() public type: OLO.Components.COLLECTION_TOGGLE_TYPES = 'inline';
    @Input() public inverted: boolean = true;
    @Input() public size: OLO.Components.BUTTON_SIZE = null;
    @Input() public feel: OLO.Components.BUTTON_FEEL | OLO.Components.BUTTON_CIRCLE_FEEL = 'secondary';
    @Input() public locationNo!: number;

    public items$!: Observable<Array<Models.CollectionTypeItem>>;
    public selected$!: Observable<Models.CollectionTypeItem>;

    constructor(
        public controllers: Controllers,
        private readonly _store: Store<State.IStateShared>
    ) { }

    ngOnInit(): void {
        if (this.locationNo) {
            this.items$ = this.controllers.collectionType.collectionTypesLinksForLocation$(this.locationNo);
            this.selected$ = this.controllers.collectionType.collectionTypesLinksSelectedForLocation$(this.locationNo);
        } else {
            this.items$ = this.controllers.collectionType.collectionTypesLinks$();
            this.selected$ = this.controllers.collectionType.collectionTypesLinksSelected$();
        }

    }

    public handleSelectedClick(data: { $event: Event; item: Models.CollectionTypeItem; }): void {
        /**
         * Created in TOLO-1423 by Konrad
         * So before invoking method to set colletion type with all the logic, you just set new value without
         * checks from main method...
         * What it caused:
         * - on the checkout view, when you change order type from DINE IN to PICKUP TIME, the pickup order type is set without basic checks, and active order
         * prompt pops in but it doesn't matter any more - order type has been already changed. Conitnue button doesn't do any more what it should.
         *
         * Move your checks to this.controllers.collectionType.setCollectionType method. Keep the logic together
         */
        // this._store.select(selectors.getCartLocationNo).pipe(
        //     take(1),
        //     withLatestFrom(
        //         this._store.select(selectors.getCurrentLocationNo),
        //     )
        // )
        //     .subscribe(([cartLocationNumber, currentLocationNumber]) => {
        //         if (cartLocationNumber === currentLocationNumber || !cartLocationNumber) {
        //             this._store.dispatch(actions.CartSetCollectionTypeid({ collectionTypeId: data.item.OrderTypeId }));
        //         }
        //     });

        this.controllers.collectionType.setCollectionType(data.item.OrderTypeId);
    }

    public trackBy(index: number, item: Models.CollectionTypeItem): number {
        return item?.Id || index;
    }
}
